import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import API_BASE_RELIO from "../../config_Relio";
import ComingSoon from "../../components/CommingSoon";

function LitMap() {
  const [compound, setCompound] = useState("");
  const [outcome, setOutcome] = useState("");
  const [mode, setMode] = useState("FAST");
  const [loading, setLoading] = useState(false);
  const COMING_SOON = false;
  const navigate = useNavigate();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // mobile
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md")); // tablet

  const handleAnalyzeClick = async (e) => {
    e.preventDefault();

    if (!compound || !outcome) {
      alert("Please enter both compound and outcome");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_RELIO}/api/run`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ compound, outcome, mode }),
      });
      if (!res.ok) {
        const err = await res.text();
        throw new Error(err);
      }
      const data = await res.json();
      navigate("/biothread/litmap/results", {
        state: { result: data },
      });
    } catch (err) {
      console.error(err);
      alert(err.message || "Relio error");
    } finally {
      setLoading(false);
    }
  };

  return COMING_SOON ? (
    <ComingSoon />
  ) : (
    <Paper
      elevation={4}
      sx={{
        maxWidth: 520,
        mx: "auto",
        p: 3,
        borderRadius: 4,
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))",
        backdropFilter: "blur(12px)",
        boxShadow: "0 12px 32px rgba(30,58,138,0.25)",
        width: "90%", // responsive width
      }}
    >
      <Typography
        variant={isSmallScreen ? "h4" : "h5"}
        fontWeight={700}
        textAlign="center"
        gutterBottom
        sx={{
          background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        RELIO
      </Typography>

      <Typography
        variant={isSmallScreen ? "body2" : "body1"}
        color="text.secondary"
        textAlign="center"
        mb={3}
      >
        Literature-driven mapping of compound targets & pathways
      </Typography>

      <form onSubmit={handleAnalyzeClick}>
        <TextField
          fullWidth
          label="Compound name *"
          value={compound}
          onChange={(e) => setCompound(e.target.value)}
          helperText="Example: Aspirin, Curcumin"
          sx={{ mb: 3 }}
          size={isSmallScreen ? "small" : "medium"}
        />

        <TextField
          fullWidth
          label="Biological outcome *"
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
          helperText="Example: Anti-inflammatory effect"
          sx={{ mb: 3 }}
          size={isSmallScreen ? "small" : "medium"}
        />

        {/* MODE SELECT */}
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={(e, val) => val && setMode(val)}
          fullWidth
          sx={{ mb: 3 }}
        >
          <ToggleButton value="FAST" sx={{ fontSize: isSmallScreen ? "0.75rem" : "1rem" }}>
            FAST (Abstracts)
          </ToggleButton>
          <ToggleButton value="FULL" sx={{ fontSize: isSmallScreen ? "0.75rem" : "1rem" }}>
            FULL (PMC Full Text)
          </ToggleButton>
        </ToggleButtonGroup>

        <Button
          type="submit"
          fullWidth
          disabled={loading}
          sx={{
            py: isSmallScreen ? 1 : 1.6,
            borderRadius: 999,
            fontWeight: 600,
            fontSize: isSmallScreen ? "0.9rem" : "1rem",
            textTransform: "none",
            background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
            color: "#fff",
            "&:hover": {
              background: "linear-gradient(90deg, #172554, #2563eb)",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={isSmallScreen ? 20 : 24} sx={{ color: "white" }} />
          ) : (
            "Analyze"
          )}
        </Button>
      </form>
    </Paper>
  );
}

export default LitMap;